import { render, staticRenderFns } from "./yearBarChart.vue?vue&type=template&id=0d24598a&scoped=true&"
import script from "./yearBarChart.vue?vue&type=script&lang=js&"
export * from "./yearBarChart.vue?vue&type=script&lang=js&"
import style0 from "./yearBarChart.vue?vue&type=style&index=0&id=0d24598a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24598a",
  null
  
)

export default component.exports